import { useRef, useState } from "react"
import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, TextField, Button, Stack } from "@mui/material"
import fetchwrapper from "../../services/interceptors/fetchwrapper"
import BackIcon from "../../components/BackIcon"
import CustomReadableTableServer from "../../components/CustomReadableTableServerSide"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"
import CustomFieldsetAccordion from "../../components/CustomFieldsetAccordion"
import { useQuery } from "@tanstack/react-query"
import CustomBackdrop from "../../components/CustomBackdrop"
import CustomAutocomplete from "../../components/CustomAutocomplete"
import CustomDatePicker from "../../components/CustomDatePicker"
import dayjs from "dayjs"
import CustomFieldset from "../../components/CustomFieldset"
import CustomAggregationSegregationComponent from "../../components/CustomAggregationSegregationComponent.js"
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const ContainerFiltrosGenerales = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto auto",
  gridTemplateAreas: `
          "IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor"
          "ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad ILocalidad"
          "IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision IRangoEmision"
          "IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar IBtnFiltrar"
        `,
  gap: "8px",
  rowGap: "12px",
  alignItems: "center",
}))

const IVendedor = styled(Box)({
  gridArea: "IVendedor",
})
const ILocalidad = styled(Box)({
  gridArea: "ILocalidad",
})

const IRangoEmision = styled(Box)({
  gridArea: "IRangoEmision",
})
const IBtnFiltrar = styled(Box)({
  gridArea: "IBtnFiltrar",
})

const ContainerRangoFechaInner = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto auto",
  gridTemplateAreas: `
            "IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal"
          `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto",
    gridTemplateAreas: `
      "IFechaInicial"
      "IFechaFinal"
    `,
    gap: "12px",
  },
}))

const RangoFechaIFechaInicial = styled(Box)({
  gridArea: "IFechaInicial",
})
const RangoFechaIFechaFinal = styled(Box)({
  gridArea: "IFechaFinal",
})

// const Comisiones = () => {
//   const [refreshCustomReadableTableServerKey, setRefreshCustomReadableTableServerKey] = useState(0) // <-- Controla el reinicio del custom readable table server
//   const [expanded, setExpanded] = useState(true)
//   const handleToggle = () => {
//     setExpanded(!expanded)
//   }
//   const [filtrosGenerales, setFiltrosGenerales] = useState({
//     localidadCB: null,
//     loccodigo: "",
//     locdescri: "",
//     vendedorCB: null,
//     vencodigo: "",
//     vennombre: "",
//     fechaInicioEmision: dayjs(new Date()),
//     fechaFinEmision: dayjs(new Date()),
//   })
//   const handleSetFiltrosGenerales = (k, v) => setFiltrosGenerales((prev) => ({ ...prev, [k]: v }))

//   const {
//     data: dataSupervisorInfo = [],
//     isError: dataErrorSupervisorInfo,
//     isFetching: isFetchingSupervisorInfo,
//     isLoading: isLoadingSupervisorInfo,
//     refetch: refetchGetAllSupervisorInfo,
//   } = useGetSupervisorInfo()
//   function useGetSupervisorInfo() {
//     return useQuery({
//       queryKey: ["ComisionSupervisorInfo"],
//       queryFn: async () => {
//         const response = await fetchwrapper(`/comisiones/getUsuarioEsSupervisor`)
//         let result = await response.json()
//         result = result.data

//         // Inicializo el key de refresh de mi readbale table server en 1, ya que en 0 no se mostrara
//         // y seteo en null las fechas de emision para que no filtre por eso
//         if (!result?.esSupervisor) {
//           setRefreshCustomReadableTableServerKey(1)
//           setFiltrosGenerales((prev) => ({
//             ...prev,
//             fechaInicioEmision: null,
//             fechaFinEmision: null,
//           }))
//         }

//         return result
//       },
//       onError: () => {
//         console.log("Error fetching data info supervisor")
//       },
//     })
//   }

//   const {
//     data: dataAllVendedores = [],
//     isError: dataErrorAllVendedores,
//     isFetching: isFetchingAllVendedores,
//     isLoading: isLoadingAllVendedores,
//     refetch: refetchGetAllAllVendedores,
//   } = useGetAllVendedores()

//   function useGetAllVendedores() {
//     return useQuery({
//       queryKey: ["ComisionesVendedores"],
//       queryFn: async () => {
//         const response = await fetchwrapper(`/comisiones/getVendedores`)
//         let result = await response.json()
//         result = result.data
//         return result
//       },
//       onError: () => {
//         console.log("Error fetching data vendedores")
//       },
//     })
//   }

//   const {
//     data: dataAllLocalidades = [],
//     isError: dataErrorAllLocalidades,
//     isFetching: isFetchingAllLocalidades,
//     isLoading: isLoadingAllLocalidades,
//     refetch: refetchGetAllAllLocalidades,
//   } = useGetAllLocalidades()
//   function useGetAllLocalidades() {
//     return useQuery({
//       queryKey: ["ComisionesLocalidades"],
//       queryFn: async () => {
//         const response = await fetchwrapper(`/comisiones/getLocalidades`)
//         let result = await response.json()
//         result = result.data
//         return result
//       },
//       onError: () => {
//         console.log("Error fetching data localidades")
//       },
//     })
//   }

//   return (
//     <ThemeProvider theme={theme}>
//       <Header />
//       <div className="main main-app p-3 p-lg-4">
//         <BackIcon />
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "0 30px 30px 30px",
//             fontSize: "25px",
//           }}
//         >
//           <b>Comisiones</b>
//         </div>
//         <CustomBackdrop
//           isLoading={
//             isLoadingAllVendedores || isFetchingAllVendedores || isLoadingAllLocalidades || isFetchingAllLocalidades
//           }
//         />
//         <Box className={StyledRoot}>
//           {dataSupervisorInfo.esSupervisor && (
//             <CustomFieldsetAccordion title="Filtros Generales" expanded={expanded} onToggle={handleToggle}>
//               <ContainerFiltrosGenerales>
//                 <IVendedor>
//                   <CustomAutocomplete
//                     label="Vendedor"
//                     selectedOption={filtrosGenerales.vendedorCB}
//                     setSelectedOption={(v) => {
//                       setFiltrosGenerales((prev) => ({
//                         ...prev,
//                         vendedorCB: v,
//                         vencodigo: v?.vencodigo ?? "",
//                         vennombre: v?.vennombre ?? "",
//                       }))
//                     }}
//                     options={dataAllVendedores}
//                   />
//                 </IVendedor>
//                 <ILocalidad>
//                   <CustomAutocomplete
//                     label="Localidad"
//                     selectedOption={filtrosGenerales.localidadCB}
//                     setSelectedOption={(v) => {
//                       setFiltrosGenerales((prev) => ({
//                         ...prev,
//                         localidadCB: v,
//                         loccodigo: v?.loccodigo ?? "",
//                         locdescri: v?.locdescri ?? "",
//                       }))
//                     }}
//                     options={dataAllLocalidades}
//                   />
//                 </ILocalidad>

//                 <IRangoEmision>
//                   <CustomFieldset title={"Rango de fechas Emisión"} sx={{ marginTop: "15px" }}>
//                     <ContainerRangoFechaInner>
//                       <RangoFechaIFechaInicial>
//                         <CustomDatePicker
//                           label="Fecha Inicial Emisión"
//                           value={filtrosGenerales.fechaInicioEmision}
//                           defaultValue={dayjs(new Date())}
//                           setValue={(v) => handleSetFiltrosGenerales("fechaInicioEmision", v)}
//                           isOptional={true}
//                           // slotProps={{ textField: { fullWidth: true } }}
//                         />
//                       </RangoFechaIFechaInicial>
//                       <RangoFechaIFechaFinal>
//                         <CustomDatePicker
//                           label="Fecha Final Emisión"
//                           value={filtrosGenerales.fechaFinEmision}
//                           defaultValue={dayjs(new Date())}
//                           setValue={(v) => handleSetFiltrosGenerales("fechaFinEmision", v)}
//                           isOptional={true}
//                           // slotProps={{ textField: { fullWidth: true } }}
//                         />
//                       </RangoFechaIFechaFinal>
//                     </ContainerRangoFechaInner>
//                   </CustomFieldset>
//                 </IRangoEmision>

//                 <IBtnFiltrar>
//                   <Button
//                     variant="contained"
//                     onClick={() => {
//                       // Refrescar el CustomReadableTableServer con los nuevos filtros de 'filtrosGenerales'
//                       setRefreshCustomReadableTableServerKey((prev) => prev + 1)
//                     }}
//                   >
//                     Filtrar
//                   </Button>
//                 </IBtnFiltrar>
//               </ContainerFiltrosGenerales>
//             </CustomFieldsetAccordion>
//           )}

//           {refreshCustomReadableTableServerKey !== 0 && (
//             <CustomReadableTableServer
//               key={refreshCustomReadableTableServerKey} // Fuerza re-montaje al cambiar
//               endpoint="/comisiones/getComisiones"
//               endpointJson={{
//                 externalFilters: {
//                   rangoFechaEmision: [filtrosGenerales.fechaInicioEmision, filtrosGenerales.fechaFinEmision],
//                   loccodigo: filtrosGenerales.loccodigo,
//                   vencodigo: filtrosGenerales.vencodigo,
//                 },
//               }}
//               errorMsgFilterSearch="Error en cargar datos"
//               queryKeyModal="comisionesGetComisiones"
//               perPage={10}
//               columnsTable={[
//                 {
//                   accessorKey: "loccodigo",
//                   header: "Código Localidad",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "locdescri",
//                   header: "Localidad",
//                   size: 150,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "vencodigo",
//                   header: "Código Vendedor",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "vennombre",
//                   header: "Nombre Vendedor",
//                   size: 150,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "ComiPorcen",
//                   header: "Porcentaje Comisión",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}%</span>,
//                 },
//                 {
//                   accessorKey: "ValComision",
//                   header: "Valor Comisión",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "ventabruta",
//                   header: "Venta Bruta",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
//                 },
//                 {
//                   accessorKey: "emision",
//                   header: "Fecha Emisión",
//                   size: 200,
//                   Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
//                 },
//               ]}
//             />
//           )}
//         </Box>
//       </div>
//     </ThemeProvider>
//   )
// }

// export default Comisiones

// ------------------------------------------------------------------------------

// const generateFakeCommissionData = () => {
//   const locations = [
//     { codigo: "LOC001", descri: "Bogotá Norte" },
//     { codigo: "LOC002", descri: "Medellín Centro" },
//     { codigo: "LOC003", descri: "Cali Sur" },
//   ]

//   const vendedores = ["Juan Pérez", "María Gómez", "Carlos Rojas", "Ana Mendoza"]
//   const articulos = [
//     { codigo: "ART100", descri: "Software Empresarial" },
//     { codigo: "ART200", descri: "Soporte Premium" },
//     { codigo: "ART300", descri: "Capacitación VIP" },
//   ]

//   const data = []

//   for (let i = 0; i < 100; i++) {
//     const loc = locations[Math.floor(Math.random() * locations.length)]
//     const ven = vendedores[Math.floor(Math.random() * vendedores.length)]
//     const art = articulos[Math.floor(Math.random() * articulos.length)]

//     const ventaBruta = Math.random() * 10000 + 5000
//     const baseComi = ventaBruta * 0.8
//     const pComi = Math.random() * 0.15 + 0.05 // 5% a 20%
//     const valorCxP = baseComi * pComi
//     const comXvalor = ventaBruta * 0.02

//     data.push({
//       loccodigo: loc.codigo,
//       locdescri: loc.descri,
//       vennombre: ven,
//       emision: new Date(2023, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
//         .toISOString()
//         .split("T")[0],
//       documento: `FAC-${Math.floor(100000 + Math.random() * 900000)}`,
//       artcodigo: art.codigo,
//       artdescri: art.descri,
//       PgstoAdm: Math.random() * 0.1 + 0.05, // 5% a 15%
//       ventabruta: Number(ventaBruta.toFixed(2)),
//       BaseComi: Number(baseComi.toFixed(2)),
//       pComi: Number(pComi.toFixed(4)),
//       ValorCxP: Number(valorCxP.toFixed(2)),
//       comXvalor: Number(comXvalor.toFixed(2)),
//       ValorCxPmasValor: Number((valorCxP + comXvalor).toFixed(2)),
//     })
//   }

//   return data
// }

// const commissionData = generateFakeCommissionData()

// Aquí se define la configuración de agregación para las columnas que se desee. (EJEMPLO)
// En este ejemplo se utiliza la agregación "max" para age y "mean" para salary, pero es totalmente configurable.
// Configuración base de columnas
// const columnsConfig = ({ averageSalary, maxAge }) => [
// {
//   header: "Age",
//   accessorKey: "age",
//   aggregationFn: "max",
//   AggregatedCell: ({ cell, table }) => (
//     <>
//       Oldest by {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
//       <Box sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}>{cell.getValue()}</Box>
//     </>
//   ),
//   Footer: () => (
//     <Stack>
//       Max Age:
//       <Box color="warning.main">{Math.round(maxAge)}</Box>
//     </Stack>
//   ),
// },
// {
//   header: "Gender",
//   accessorKey: "gender",
//   GroupedCell: ({ cell, row }) => (
//     <Box sx={{ color: "primary.main" }}>
//       <strong>{cell.getValue()}s </strong> ({row.subRows?.length})
//     </Box>
//   ),
// },
// {
//   header: "Salary",
//   accessorKey: "salary",
//   aggregationFn: "mean",
//   AggregatedCell: ({ cell, table }) => (
//     <>
//       Average by {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
//       <Box sx={{ color: "success.main", fontWeight: "bold" }}>
//         {cell.getValue()?.toLocaleString?.("en-US", {
//           style: "currency",
//           currency: "USD",
//           minimumFractionDigits: 0,
//           maximumFractionDigits: 0,
//         })}
//       </Box>
//     </>
//   ),
//   Cell: ({ cell }) => (
//     <>
//       {cell.getValue()?.toLocaleString?.("en-US", {
//         style: "currency",
//         currency: "USD",
//         minimumFractionDigits: 0,
//         maximumFractionDigits: 0,
//       })}
//     </>
//   ),
//   Footer: () => (
//     <Stack>
//       Average Salary:
//       <Box color="warning.main">
//         {averageSalary?.toLocaleString?.("en-US", {
//           style: "currency",
//           currency: "USD",
//           minimumFractionDigits: 0,
//           maximumFractionDigits: 0,
//         })}
//       </Box>
//     </Stack>
//   ),
// },
// ]

const Comisiones = () => {
  const [refreshCustomReadableTableServerKey, setRefreshCustomReadableTableServerKey] = useState(0) // <-- Controla el reinicio del custom readable table server
  const [expanded, setExpanded] = useState(true)
  const handleToggle = () => {
    setExpanded(!expanded)
  }
  const [filtrosGenerales, setFiltrosGenerales] = useState({
    localidadCB: null,
    loccodigo: "",
    locdescri: "",
    vendedorCB: null,
    vencodigo: "",
    vennombre: "",
    fechaInicioEmision: dayjs(new Date()),
    fechaFinEmision: dayjs(new Date()),
  })
  const handleSetFiltrosGenerales = (k, v) => setFiltrosGenerales((prev) => ({ ...prev, [k]: v }))

  const {
    data: dataSupervisorInfo = [],
    isError: dataErrorSupervisorInfo,
    isFetching: isFetchingSupervisorInfo,
    isLoading: isLoadingSupervisorInfo,
    refetch: refetchGetAllSupervisorInfo,
  } = useGetSupervisorInfo()
  function useGetSupervisorInfo() {
    return useQuery({
      queryKey: ["ComisionSupervisorInfo"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getUsuarioEsSupervisor`)
        let result = await response.json()
        result = result.data

        // Inicializo el key de refresh de mi readbale table server en 1, ya que en 0 no se mostrara
        // y seteo en null las fechas de emision para que no filtre por eso
        if (!result?.esSupervisor) {
          setRefreshCustomReadableTableServerKey(1)
          setFiltrosGenerales((prev) => ({
            ...prev,
            fechaInicioEmision: null,
            fechaFinEmision: null,
          }))
        }

        return result
      },
      onError: () => {
        console.log("Error fetching data info supervisor")
      },
    })
  }

  const {
    data: dataAllVendedores = [],
    isError: dataErrorAllVendedores,
    isFetching: isFetchingAllVendedores,
    isLoading: isLoadingAllVendedores,
    refetch: refetchGetAllAllVendedores,
  } = useGetAllVendedores()

  function useGetAllVendedores() {
    return useQuery({
      queryKey: ["ComisionesVendedores"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getVendedores`)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data vendedores")
      },
    })
  }

  const {
    data: dataAllLocalidades = [],
    isError: dataErrorAllLocalidades,
    isFetching: isFetchingAllLocalidades,
    isLoading: isLoadingAllLocalidades,
    refetch: refetchGetAllAllLocalidades,
  } = useGetAllLocalidades()
  function useGetAllLocalidades() {
    return useQuery({
      queryKey: ["ComisionesLocalidades"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getLocalidades`)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data localidades")
      },
    })
  }

  const {
    data: dataAllComisiones = [],
    isError: dataErrorAllComisiones,
    isFetching: isFetchingAllComisiones,
    isLoading: isLoadingAllComisiones,
    refetch: refetchGetAllAllComisiones,
  } = useGetAllComisiones()

  function useGetAllComisiones(externalFilters = {}) {
    return useQuery({
      queryKey: ["ComisionesValoresFinales"],
      queryFn: async () => {
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            externalFilters: {
              rangoFechaEmision: [filtrosGenerales.fechaInicioEmision, filtrosGenerales.fechaFinEmision],
              loccodigo: filtrosGenerales.loccodigo,
              vencodigo: filtrosGenerales.vencodigo,
            },
          }),
        }
        const response = await fetchwrapper(`/comisiones/getAllComisiones`, options)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data comisiones")
      },
      enabled: refreshCustomReadableTableServerKey > 0, // Si el refresh es mayor a 0 entonces va ejecutar esta peticion en el rederizado inicial (no es supervisor) y sino tendra que espererar a que de click en filtrar (es supervisor)
    })
  }

  const handleClickFiltrarBtn = async () => {
    await refetchGetAllAllComisiones()

    // Refrescar el CustomReadableTableServer con los nuevos filtros de 'filtrosGenerales'
    setRefreshCustomReadableTableServerKey((prev) => prev + 1)
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Comisiones</b>
        </div>
        <CustomBackdrop
          isLoading={
            isLoadingAllVendedores ||
            isFetchingAllVendedores ||
            isLoadingAllLocalidades ||
            isFetchingAllLocalidades ||
            isLoadingSupervisorInfo ||
            isFetchingSupervisorInfo ||
            isLoadingAllComisiones ||
            isFetchingAllComisiones
          }
        />
        <Box className={StyledRoot}>
          {dataSupervisorInfo.esSupervisor && (
            <CustomFieldsetAccordion title="Filtros Generales" expanded={expanded} onToggle={handleToggle}>
              <ContainerFiltrosGenerales>
                <IVendedor>
                  <CustomAutocomplete
                    label="Vendedor"
                    selectedOption={filtrosGenerales.vendedorCB}
                    setSelectedOption={(v) => {
                      setFiltrosGenerales((prev) => ({
                        ...prev,
                        vendedorCB: v,
                        vencodigo: v?.vencodigo ?? "",
                        vennombre: v?.vennombre ?? "",
                      }))
                    }}
                    options={dataAllVendedores}
                  />
                </IVendedor>
                <ILocalidad>
                  <CustomAutocomplete
                    label="Localidad"
                    selectedOption={filtrosGenerales.localidadCB}
                    setSelectedOption={(v) => {
                      setFiltrosGenerales((prev) => ({
                        ...prev,
                        localidadCB: v,
                        loccodigo: v?.loccodigo ?? "",
                        locdescri: v?.locdescri ?? "",
                      }))
                    }}
                    options={dataAllLocalidades}
                  />
                </ILocalidad>

                <IRangoEmision>
                  <CustomFieldset title={"Rango de fechas Emisión"} sx={{ marginTop: "15px" }}>
                    <ContainerRangoFechaInner>
                      <RangoFechaIFechaInicial>
                        <CustomDatePicker
                          label="Fecha Inicial Emisión"
                          value={filtrosGenerales.fechaInicioEmision}
                          defaultValue={dayjs(new Date())}
                          setValue={(v) => handleSetFiltrosGenerales("fechaInicioEmision", v)}
                          isOptional={true}
                          // slotProps={{ textField: { fullWidth: true } }}
                        />
                      </RangoFechaIFechaInicial>
                      <RangoFechaIFechaFinal>
                        <CustomDatePicker
                          label="Fecha Final Emisión"
                          value={filtrosGenerales.fechaFinEmision}
                          defaultValue={dayjs(new Date())}
                          setValue={(v) => handleSetFiltrosGenerales("fechaFinEmision", v)}
                          isOptional={true}
                          // slotProps={{ textField: { fullWidth: true } }}
                        />
                      </RangoFechaIFechaFinal>
                    </ContainerRangoFechaInner>
                  </CustomFieldset>
                </IRangoEmision>

                <IBtnFiltrar>
                  <Button variant="contained" onClick={handleClickFiltrarBtn}>
                    Filtrar
                  </Button>
                </IBtnFiltrar>
              </ContainerFiltrosGenerales>
            </CustomFieldsetAccordion>
          )}

          {refreshCustomReadableTableServerKey !== 0 && (
            <CustomAggregationSegregationComponent
              data={dataAllComisiones}
              columnsConfig={({ totalSumVentabruta, totalSumBaseComision, totalSumCXP, totalSumCXV, totalSumCXPV }) => [
                {
                  accessorKey: "locdescri",
                  header: "Descripción Localidad",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "vennombre",
                  header: "Nombre Vendedor",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "emision",
                  header: "Emisión",
                  size: 200,
                  Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
                },
                {
                  accessorKey: "documento",
                  header: "Documento",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "clinombre",
                  header: "Cliente",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "artdescri",
                  header: "Descripción Artículo",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "PgstoAdm",
                  header: "% Gasto Adm",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "ventabruta",
                  header: "Venta Bruta",
                  size: 200,
                  accessorFn: (row) => Number(row.ventabruta) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total Venta Bruta:
                      <Box color="warning.main">
                        {totalSumVentabruta?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
                {
                  accessorKey: "BaseComi",
                  header: "Base Comisión",
                  size: 200,
                  accessorFn: (row) => Number(row.BaseComi) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total Base Comisión:
                      <Box color="warning.main">
                        {totalSumBaseComision?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
                {
                  accessorKey: "pComi",
                  header: "% Comisión",
                  size: 200,
                  Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                },
                {
                  accessorKey: "ValorCxP",
                  header: "V.comi.%",
                  size: 200,
                  accessorFn: (row) => Number(row.ValorCxP) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total V.comi.%:
                      <Box color="warning.main">
                        {totalSumCXP?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
                {
                  accessorKey: "comXvalor",
                  header: "ComiValor",
                  size: 200,
                  accessorFn: (row) => Number(row.comXvalor) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total ComiValor:
                      <Box color="warning.main">
                        {totalSumCXV?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
                {
                  accessorKey: "ValorCxPmasValor",
                  header: "V.TotalComi",
                  size: 200,
                  accessorFn: (row) => Number(row.ValorCxPmasValor) || 0, // El backend me esta devolviendo string de dos decimales, asi que necesito pasarlos de string a number
                  aggregationFn: "sum",
                  AggregatedCell: ({ cell, table }) => (
                    <>
                      Suma por {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                      <Box sx={{ color: "success.main", fontWeight: "bold" }}>
                        {cell.getValue()?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </>
                  ),
                  Cell: ({ cell }) => (
                    <span>
                      {cell.getValue()?.toLocaleString?.("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  ),
                  Footer: () => (
                    <Stack>
                      Total Valor V.TotalComi:
                      <Box color="warning.main">
                        {totalSumCXPV?.toLocaleString?.("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Box>
                    </Stack>
                  ),
                },
              ]}
              aggregations={{
                totalSumVentabruta: (data) => data.reduce((acc, curr) => acc + Number(curr.ventabruta), 0),
                totalSumBaseComision: (data) => data.reduce((acc, curr) => acc + Number(curr.BaseComi), 0),
                totalSumCXP: (data) => data.reduce((acc, curr) => acc + Number(curr.ValorCxP), 0),
                totalSumCXV: (data) => data.reduce((acc, curr) => acc + Number(curr.comXvalor), 0),
                totalSumCXPV: (data) => data.reduce((acc, curr) => acc + Number(curr.ValorCxPmasValor), 0),
                // maxAge: (data) => data.reduce((acc, curr) => Math.max(acc, curr.age), 0),
              }}
              tableOptions={{
                initialState: {
                  grouping: [
                    // "state"
                  ],
                  sorting: [
                    // { id: "state", desc: false }
                  ],
                },
              }}
            />
          )}
        </Box>
      </div>
    </ThemeProvider>
  )
}
export default Comisiones
